import router from '../../router';

export function isExistingQuoteOpen() {
  return Boolean(router.currentRoute.params.quoteId);
}
